enum InternationalPaymentTransactionStatusDetail {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  IN_PROGRESS = 'IN_PROGRESS',
  LACK_OF_FUNDS = 'LACK_OF_FUNDS',
  SCA_NEEDED = 'SCA_NEEDED',
  STOPPED_BY_USER = 'STOPPED_BY_USER',
  TO_BE_APPROVED = 'TO_BE_APPROVED',
}

export default InternationalPaymentTransactionStatusDetail;
